import React from 'react';
import {
    Placeholder,
    Card,
    CardBody,
    Row,
    Col,
    Container
} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const ServiceLoadingComponent = () => {
    return (
        <div className="!mt-0 !p-0">
            <div>
                <Placeholder className={"w-full rounded-md flex gap-x-3 flex-wrap items-center justify-between bg-[#eaeaea5e] h-fit p-4"} animation={"wave"}   tag={"div"}>
                    <Placeholder className={"!bg-white size-10 rounded-full"}></Placeholder>
                    <Placeholder className={"!bg-white size-10 rounded-full"}></Placeholder>
                    <Placeholder className={"!bg-white size-10 rounded-full"}></Placeholder>
                    <Placeholder className={"!bg-white size-10 rounded-full"}></Placeholder>
                </Placeholder>
            </div>
            <div>
                <Placeholder className={" !bg-[#eaeaea5e] w-14 !min-h-1 h-3 "} tag={"label"} />
                <Placeholder className={"w-full rounded-md flex gap-x-3 flex-wrap items-center justify-between bg-[#eaeaea5e] min-h-9 p-4"} animation={"wave"}   tag={"div"} />
            </div>
            <div>
                <Placeholder className={" !bg-[#eaeaea5e] w-14 !min-h-1 h-3 "} tag={"label"} />
                <div className={"flex align-items-center w-full space-x-3 justify-between"}>
                    <Placeholder className={"basis-1/4 border border-gray-100/10 rounded-md flex gap-x-3 flex-wrap items-center justify-between bg-[#eaeaea5e] min-h-9 h-20 p-2"} animation={"wave"}   tag={"div"} />
                    <Placeholder className={"basis-1/4 border border-gray-100/10 rounded-md flex gap-x-3 flex-wrap items-center justify-between bg-[#eaeaea5e] min-h-9 h-20 p-2"} animation={"wave"}   tag={"div"} />
                    <Placeholder className={"basis-1/4 border border-gray-100/10 rounded-md flex gap-x-3 flex-wrap items-center justify-between bg-[#eaeaea5e] min-h-9 h-20 p-2"} animation={"wave"}   tag={"div"} />
                    <Placeholder className={"basis-1/4 border border-gray-100/10 rounded-md flex gap-x-3 flex-wrap items-center justify-between bg-[#eaeaea5e] min-h-9 h-20 p-2"} animation={"wave"}   tag={"div"} />
                </div>
            </div>
            <div>
                <Placeholder className={" !bg-[#eaeaea5e] w-14 !min-h-1 h-3 "} tag={"label"} />
                <Placeholder className={"w-full rounded-md flex gap-x-3 flex-wrap items-center justify-between bg-[#eaeaea5e] min-h-28 p-2"} animation={"wave"} tag={"div"} />
            </div>
            {/*<Card className="shadow-sm">*/}
            {/*    <CardBody>*/}
            {/*        /!* Header Section *!/*/}
            {/*        <div className="text-center mb-4">*/}
            {/*            <Placeholder tag="h2" animation="wave" className="w-50 mx-auto">*/}
            {/*                <Placeholder xs={6} />*/}
            {/*            </Placeholder>*/}
            {/*            <Placeholder tag="p" animation="wave" className="w-25 mx-auto">*/}
            {/*                <Placeholder xs={12} />*/}
            {/*            </Placeholder>*/}
            {/*        </div>*/}

            {/*        /!* Bill Information *!/*/}
            {/*        <Row className="mb-4">*/}
            {/*            <Col md={6}>*/}
            {/*                <div className="mb-3">*/}
            {/*                    <Placeholder tag="h5" animation="wave" className="w-50">*/}
            {/*                        <Placeholder xs={4} />*/}
            {/*                    </Placeholder>*/}
            {/*                    <Placeholder animation="wave">*/}
            {/*                        <Placeholder xs={8} />*/}
            {/*                    </Placeholder>*/}
            {/*                </div>*/}
            {/*            </Col>*/}
            {/*            <Col md={6}>*/}
            {/*                <div className="mb-3">*/}
            {/*                    <Placeholder tag="h5" animation="wave" className="w-50">*/}
            {/*                        <Placeholder xs={4} />*/}
            {/*                    </Placeholder>*/}
            {/*                    <Placeholder animation="wave">*/}
            {/*                        <Placeholder xs={6} />*/}
            {/*                    </Placeholder>*/}
            {/*                </div>*/}
            {/*            </Col>*/}
            {/*        </Row>*/}

            {/*        /!* Bill Details Card *!/*/}
            {/*        <Card className="bg-light mb-4">*/}
            {/*            <CardBody>*/}
            {/*                <Row>*/}
            {/*                    <Col md={8}>*/}
            {/*                        <Placeholder tag="h4" animation="wave" className="w-75 mb-3">*/}
            {/*                            <Placeholder xs={6} />*/}
            {/*                        </Placeholder>*/}
            {/*                        <div className="mb-2">*/}
            {/*                            <Placeholder animation="wave" className="w-50">*/}
            {/*                                <Placeholder xs={4} />*/}
            {/*                            </Placeholder>*/}
            {/*                        </div>*/}
            {/*                        <div className="mb-2">*/}
            {/*                            <Placeholder animation="wave" className="w-75">*/}
            {/*                                <Placeholder xs={6} />*/}
            {/*                            </Placeholder>*/}
            {/*                        </div>*/}
            {/*                        <div className="mb-2">*/}
            {/*                            <Placeholder animation="wave" className="w-50">*/}
            {/*                                <Placeholder xs={4} />*/}
            {/*                            </Placeholder>*/}
            {/*                        </div>*/}
            {/*                    </Col>*/}
            {/*                    <Col md={4} className="text-end">*/}
            {/*                        <Placeholder tag="h3" animation="wave" className="w-100 mb-3">*/}
            {/*                            <Placeholder xs={8} />*/}
            {/*                        </Placeholder>*/}
            {/*                        <Placeholder animation="wave" className="w-75">*/}
            {/*                            <Placeholder xs={6} />*/}
            {/*                        </Placeholder>*/}
            {/*                    </Col>*/}
            {/*                </Row>*/}
            {/*            </CardBody>*/}
            {/*        </Card>*/}

            {/*        /!* Payment Method Selection *!/*/}
            {/*        <div className="mb-4">*/}
            {/*            <Placeholder tag="h5" animation="wave" className="w-25 mb-3">*/}
            {/*                <Placeholder xs={3} />*/}
            {/*            </Placeholder>*/}
            {/*            <Row>*/}
            {/*                <Col md={4} className="mb-3">*/}
            {/*                    <Card className="h-100">*/}
            {/*                        <CardBody className="text-center">*/}
            {/*                            <Placeholder animation="wave" className="mb-2">*/}
            {/*                                <Placeholder xs={8} />*/}
            {/*                            </Placeholder>*/}
            {/*                            <Placeholder animation="wave" className="w-50">*/}
            {/*                                <Placeholder xs={4} />*/}
            {/*                            </Placeholder>*/}
            {/*                        </CardBody>*/}
            {/*                    </Card>*/}
            {/*                </Col>*/}
            {/*                <Col md={4} className="mb-3">*/}
            {/*                    <Card className="h-100">*/}
            {/*                        <CardBody className="text-center">*/}
            {/*                            <Placeholder animation="wave" className="mb-2">*/}
            {/*                                <Placeholder xs={8} />*/}
            {/*                            </Placeholder>*/}
            {/*                            <Placeholder animation="wave" className="w-50">*/}
            {/*                                <Placeholder xs={4} />*/}
            {/*                            </Placeholder>*/}
            {/*                        </CardBody>*/}
            {/*                    </Card>*/}
            {/*                </Col>*/}
            {/*                <Col md={4} className="mb-3">*/}
            {/*                    <Card className="h-100">*/}
            {/*                        <CardBody className="text-center">*/}
            {/*                            <Placeholder animation="wave" className="mb-2">*/}
            {/*                                <Placeholder xs={8} />*/}
            {/*                            </Placeholder>*/}
            {/*                            <Placeholder animation="wave" className="w-50">*/}
            {/*                                <Placeholder xs={4} />*/}
            {/*                            </Placeholder>*/}
            {/*                        </CardBody>*/}
            {/*                    </Card>*/}
            {/*                </Col>*/}
            {/*            </Row>*/}
            {/*        </div>*/}

            {/*        /!* Payment Form *!/*/}
            {/*        <div className="mb-4">*/}
            {/*            <Placeholder tag="h5" animation="wave" className="w-25 mb-3">*/}
            {/*                <Placeholder xs={3} />*/}
            {/*            </Placeholder>*/}
            {/*            <Row>*/}
            {/*                <Col md={6} className="mb-3">*/}
            {/*                    <Placeholder animation="wave" className="w-25 mb-2">*/}
            {/*                        <Placeholder xs={3} />*/}
            {/*                    </Placeholder>*/}
            {/*                    <Placeholder animation="wave">*/}
            {/*                        <Placeholder xs={12} />*/}
            {/*                    </Placeholder>*/}
            {/*                </Col>*/}
            {/*                <Col md={6} className="mb-3">*/}
            {/*                    <Placeholder animation="wave" className="w-25 mb-2">*/}
            {/*                        <Placeholder xs={3} />*/}
            {/*                    </Placeholder>*/}
            {/*                    <Placeholder animation="wave">*/}
            {/*                        <Placeholder xs={12} />*/}
            {/*                    </Placeholder>*/}
            {/*                </Col>*/}
            {/*            </Row>*/}
            {/*            <Row>*/}
            {/*                <Col md={6} className="mb-3">*/}
            {/*                    <Placeholder animation="wave" className="w-25 mb-2">*/}
            {/*                        <Placeholder xs={3} />*/}
            {/*                    </Placeholder>*/}
            {/*                    <Placeholder animation="wave">*/}
            {/*                        <Placeholder xs={12} />*/}
            {/*                    </Placeholder>*/}
            {/*                </Col>*/}
            {/*                <Col md={6} className="mb-3">*/}
            {/*                    <Placeholder animation="wave" className="w-25 mb-2">*/}
            {/*                        <Placeholder xs={3} />*/}
            {/*                    </Placeholder>*/}
            {/*                    <Placeholder animation="wave">*/}
            {/*                        <Placeholder xs={12} />*/}
            {/*                    </Placeholder>*/}
            {/*                </Col>*/}
            {/*            </Row>*/}
            {/*        </div>*/}

            {/*        /!* Action Buttons *!/*/}
            {/*        <div className="d-flex gap-3 justify-content-end">*/}
            {/*            <Placeholder animation="wave" className="w-25">*/}
            {/*                <Placeholder xs={12} style={{ height: '38px' }} />*/}
            {/*            </Placeholder>*/}
            {/*            <Placeholder animation="wave" className="w-25">*/}
            {/*                <Placeholder xs={12} style={{ height: '38px' }} />*/}
            {/*            </Placeholder>*/}
            {/*        </div>*/}
            {/*    </CardBody>*/}
            {/*</Card>*/}
        </div>
    );
};
export const ServiceLoadingComponentB = () => {
    return (
        <div className="!mt-0 !p-0">
            <div className={"mb-3"}>
                <Placeholder className={" !bg-[#eaeaea5e] w-14 !min-h-1 h-3 "} tag={"label"} />
                <div className={"flex align-items-center w-full space-x-3 justify-between"}>
                    <Placeholder className={"basis-1/2 border border-gray-100/10 rounded-md flex gap-x-3 flex-wrap items-center justify-between bg-[#eaeaea5e] min-h-9 h-40 p-2"} animation={"wave"}   tag={"div"} />
                    <Placeholder className={"basis-1/2 border border-gray-100/10 rounded-md flex gap-x-3 flex-wrap items-center justify-between bg-[#eaeaea5e] min-h-9 h-40 p-2"} animation={"wave"}   tag={"div"} />
                </div>
            </div>
            <Placeholder className={"w-full rounded-xl border border-gray-100/10 flex gap-x-3 flex-wrap items-center justify-between bg-[#eaeaea5e] min-h-9 h-40 p-2"} animation={"wave"}   tag={"div"} /></div>
    );
};


